import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { SectionContainer } from '../ui/SectionContainer';
import { StepItem } from '../ui/StepItem';
import { WHAT_TO_EXPECT } from '../../constants';

interface WhatToExpectSectionProps {
  compact?: boolean;
}

/**
 * What to Expect section for the Demo page
 * Displays the demo process steps
 */
export const WhatToExpectSection: React.FC<WhatToExpectSectionProps> = ({ compact = false }) => {
  return (
    <SectionContainer variant="default" compact={compact}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            fontSize: { xs: '1.75rem', md: '2rem' },
          }}
        >
          What to Expect
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mx: 'auto' }}>
          Our demo process is designed to help you understand exactly how Lecturo can help your
          institution.
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        {WHAT_TO_EXPECT.map((step) => (
          <Grid item key={step.number} xs={12} sm={6} md={3}>
            <StepItem number={step.number} title={step.title} description={step.description} />
          </Grid>
        ))}
      </Grid>
    </SectionContainer>
  );
};
